<ul class="pagination justify-content-center">
  <li class="page-item " [ngClass]="{'disabled' : pageNumber == 1}">
    <a class="page-link" (click)="onPrevClicked()" aria-label="Previous">
      <span aria-hidden="true">&laquo;</span>
      <span class="sr-only">Previous</span>
    </a>
  </li>
  <li class="page-item" *ngFor="let pgNum of pageList; let i = index">
    <a class="page-link" (click)="onPageNumberClicked(pgNum)">{{pgNum}}</a>
  </li>
  <li class="page-item" [ngClass]="{'disabled' : rowsCount != itemCount}">
    <a class="page-link" aria-label="Next" (click)="onNextClicked()">
      <span aria-hidden="true">&raquo;</span>
      <span class="sr-only">Next</span>
    </a>
  </li>
</ul>
